import {
  Box,
  CardActionArea,
  Grid,
  Link,
  Typography,
  useTheme,
} from "@mui/material";

import FlaggedConcerns from "./FlaggedConcerns";
import APINewsArticle from "../../../types/APINewsArticle";
import { getRelativeTimeString } from "../../../utilities/formatting";

export interface Props {
  article: APINewsArticle;
  index: number;
}

export default function Article({ article, index }: Props) {
  const publishedDate = article.date ? new Date(article.date) : null;
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", mt: index === 0 ? "0px" : "16px" }}>
      <CardActionArea component={Link} href={article.link} target="_blank">
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography component="div" variant="subtitle1">
            <strong>{article.title}</strong>
          </Typography>
          {article.snippet && (
            <Typography
              variant="subtitle1"
              component="div"
              sx={{
                color: "text.secondary",
                marginTop: "4px",
                lineHeight: 1.25,
              }}
            >
              {article.snippet}
            </Typography>
          )}
          <Box
            sx={{
              mt: "4px",
            }}
          >
            <Grid
              container
              spacing={2}
              columnSpacing={{ xs: 2, md: 6 }}
              rowSpacing={{ xs: 2, md: 2 }}
            >
              <Grid size={6}>
                {article.concerns ? (
                  <FlaggedConcerns flaggedConcerns={article.concerns} />
                ) : (
                  <Typography variant="caption">
                    No concerning content found
                  </Typography>
                )}
              </Grid>
              {publishedDate && (
                <Grid size={6}>
                  <Typography
                    sx={{
                      color: theme.palette.grey[600],
                      paddingTop: "7px",
                      paddingRight: "8px",
                      textAlign: "right",
                    }}
                    variant="subtitle2"
                  >
                    Published {getRelativeTimeString(publishedDate, "en-US")}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Box>
        </Box>
      </CardActionArea>
    </Box>
  );
}
